import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {faFileWord} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


interface IShowChangedCellsProps {
}


export const ShowChangedCells: FunctionComponent<IShowChangedCellsProps> = observer<FunctionComponent<IShowChangedCellsProps>>(function (props) {

    const {translateStore} = useStorageTranslateContext()
    const {languageFileModel} = useModelContext()

    let dataLanguageResponse = languageFileModel.dataLanguage.get()

    let disabled = !dataLanguageResponse;

    return <IconButton
        disabled={disabled}
        className={translateStore.changeWords ? "featureButtons__i featureButtons__i--active featureButtons__i--words" : "featureButtons__i featureButtons__i--words"}
        aria-hidden="true"
        title={translateStore.changeWords ? "Show all words" : "Show changed words" }
        onClick={() => {
            translateStore.hideWords = false
            translateStore.changeWords = !translateStore.changeWords
             translateStore.gridApi.onFilterChanged();
            translateStore.filteredSet.clear()
        }}
    >
        <FontAwesomeIcon icon={faFileWord}/>
    </IconButton>
});

